export function dashboardUnclaimedWorkOrdersItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-item-template-unclaimed-work-orders.html";
    const html = /*html*/`<apex-dashboard-unclaimed-work-orders-container>
        </apex-dashboard-unclaimed-work-orders-container>`;
    $templateCache.put(path, html);
}

export function dashboardUnclaimedWorkOrdersListItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-list-item-template-unclaimed-work-orders.html";
    const html = /*html*/`
        <p ng-if="dashboard.count > 0"> Some work orders are not assigned to employees.</p>
        <p ng-if="dashboard.count === 0">
            <span class="glyphicon fas fa-check-circle"></span>
            All work orders are assigned to an employee.
        </p>
    `;
    $templateCache.put(path, html);
}
